var map = {
	"./item-bg-icon.png": "8bf0",
	"./school-icon1.png": "3af5",
	"./school-icon2.png": "c864",
	"./school-icon3.png": "7758",
	"./school-title1.png": "4308",
	"./school-title2.png": "da0d",
	"./school-title3.png": "7a0c",
	"./talent-flow.png": "da8c",
	"./workList-icon1.png": "0af3",
	"./workList-icon2.png": "dcca",
	"./workList-icon3.png": "ff7c",
	"./workList-icon4.png": "c16d",
	"./workList-icon5.png": "a17d",
	"./workList-title1.png": "063a",
	"./workList-title2.png": "b409"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "38d2";